import { Button, CircularProgress, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useMemo, useState } from 'react';
import { DataGridStyle } from '../../shared/sharedStyles';
import axiosInstance from '../../axios.config';

export const QuizQuestionsTable = ({ lngsltd, data, quizid, handleEditClick, handleDelete }) => {

    const renderWrappedCell = (value) => (
        <div
            style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                lineHeight: '1.4',
                textAlign: 'center',
                width: '100%',
                padding: 1
            }}
        >
            {value}
        </div>
    );


    const columns = useMemo(() => {
        return [
            {
                field: 'questionNo', headerName: lngsltd["QuestionNo"], flex: 1.0, headerAlign: 'center', align: 'center',
                renderCell: (params) => renderWrappedCell(params.value),
            },
            {
                field: 'questionText', headerName: lngsltd["Question Text"], flex: 2, headerAlign: 'center', align: 'center',
                renderCell: (params) => renderWrappedCell(params.value),
            },
            {
                field: 'options', headerName: lngsltd["Options"], flex: 1.5, headerAlign: 'center', align: 'center',
                renderCell: (params) => renderWrappedCell(params.value),
            },
            {
                field: 'correctOption', headerName: lngsltd["Correct Option"], flex: 1.2, headerAlign: 'center', align: 'center',
                renderCell: (params) => renderWrappedCell(params.value),
            },
            {
                field: 'image',
                headerName: lngsltd["Image"],
                flex: 1,
                headerAlign: 'center',
                align: 'center',
                renderCell: (params) =>
                    params.row.imageName && params.row.imageName !== 'No Image' && params.row.imageName !== null ? (
                        <img
                            src={`${axiosInstance.defaults.baseURL}/Question/Image/${params.row.quizID}/${params.row.questionNo}/${params.row.imageName}`}
                            alt="Question"
                            style={{ maxWidth: '100px', maxHeight: '100px' }}
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    ) : null,
            },

            {
                field: 'language', // New column for language
                headerName: lngsltd["Language"], // Header name for the column
                flex: 1,
                headerAlign: 'center',
                align: 'center',
                renderCell: (params) => renderWrappedCell(params.value),
            },

            {
                field: 'actions',
                headerName: lngsltd["Actions"],
                flex: 1.5,
                headerAlign: 'center',
                align: 'center',
                renderCell: (params) => {
                    return (<>
                        <Button

                            color="primary"
                            onClick={() => handleEditClick(params.row)}
                            style={{ marginRight: 8 }}
                        >
                            {lngsltd["Edit"]}
                        </Button>
                        <Button

                            color="secondary"
                            onClick={() => handleDelete(params.row.id)}
                        >
                            {lngsltd["Delete"]}
                        </Button>
                    </>)
                },
            },
        ]
    }, []);

    const rows = useMemo(() => {
    return data?.map((q, i) => ({
        id: q.id,
        ...q,

        correctOption: Array.isArray(q.correctOptions)
            ? q.correctOptions.join(", ")
            : q.correctOption,

        language: q.languageCode === 'en-US'
            ? 'English'
            : 'Norwegian',
    }))
}, [data]);

    if (data == null) {
        return (
            <Typography variant="h6" align="center" sx={{ paddingTop: '25px' }}>
                <CircularProgress />
            </Typography>
        );
    }
    return (

        <div style={{ width: '100%', height: '40vh'}}>
            <DataGrid
                rows={rows}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 25]}
                disableSelectionOnClick
                disableColumnResize
                getRowHeight={() => 'auto'}
                disableVirtualization   
                hideFooter   
                sx={{
                    ...DataGridStyle, // ✅ keep your existing styles

                    '& .MuiDataGrid-cell': {
                        display: 'flex',
                        alignItems: 'center',     // ✅ vertical center
                        justifyContent: 'center', // ✅ horizontal center
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        lineHeight: '1.4 !important',
                        py: 1,
                    },

                    '& .MuiDataGrid-row': {
                        maxHeight: 'none !important', // ✅ allow row to expand
                        justifyContent: 'center',
                    },
                    '& .MuiDataGrid-virtualScroller': {
                        overflowY: 'auto',
                    }
                }}
            />
        </div>

    );
}